import _ from 'underscore';
import PageApp from 'pageApp';
import Logger from '@component/common/src/util/Logger';
import ProsEvents from '../util/ProsEvents';

let zoneRecommendationMap = {};

const RecommendationStore = {

  get(workflow) {
    return zoneRecommendationMap[workflow];
  },

  storeSingleZone({ opts, workflow, recommendedItems }) {
    if (recommendedItems) {
      zoneRecommendationMap[workflow] = recommendedItems;
      PageApp.channel.trigger(`${workflow}${ProsEvents.dataAvailable}`, recommendedItems, opts);
    } else {
      PageApp.channel.trigger(`${workflow}${ProsEvents.failure}`, opts);
    }
  },

  /**
   * for multi-zones read it from recommendations : {MCOM-NAVAPP-PDP_ZONE_A:{},MCOM-NAVAPP-PDP_ZONE_A:{}}
   * @param opts
   * @param json
   */
  storeMultiZone({ opts, json }) {
    const { requester } = opts;
    const zones = opts.zone.split('|');
    zones.forEach((zone) => {
      const workflow = this.getWorkflow(opts, zone); // MCOM-NAVAPP-PDP_ZONE_A-${productId}
      const zoneData = json.recommendationsOnAllZones[`${requester}-${zone}`];
      try {
        if ((zoneData.recommendedIdsList && !_.isEmpty(zoneData.recommendedIdsList))) {
          this.storeSingleZone({
            opts,
            workflow,
            headerText: zoneData.headerText,
            recommendedItems: zoneData, // ZONE KEY => MCOM-NAVAPP-PDP_ZONE_A
          });
        }
      } catch (err) {
        Logger.info(`Recommendations for zone ${zone}, is empty or not valid`);
      }
    });

    if (zones.length > 0) {
      PageApp.channel.trigger(`${opts.zone}${ProsEvents.dataAvailable}`, opts, json);
    }
  },

  getMultiZoneData(opts) {
    const multiZoneData = [];
    const zones = opts.zone.split('|');

    zones.forEach((zone) => {
      const workflow = this.getWorkflow(opts, zone); // MCOM-NAVAPP-PDP_ZONE_A-${productId}
      const zoneData = RecommendationStore.get(workflow);
      if (zoneData) {
        multiZoneData.push({
          zone,
          headerText: zoneData.headerText,
        });
      }
    });

    return multiZoneData;
  },

  /**
   * Private method, not to be used by outside
   * @param opts = {zone:PDP_ZONE_A|PDP_ZONE_B}
   * @param json = {recommendedItems:[],
                           recommendations:{
                               MCOM-NAVAPP-PDP_ZONE_A:{
                                   choiceId:'',
                                   productIds:[1,2,3,4,5,6,7,8,9,10]
                               },
                               MCOM-NAVAPP-PDP_ZONE_B:{
                                   choiceId:'',
                                   productIds:[1,2,3,4,5,6,7,8,9,10]
                               }
                           } }
   */
  store(opts, json) {
    if (!json || !opts || !(json.recommendedItems || !_.isEmpty(json.recommendationsOnAllZones))) {
      return false;
    }
    // For single zone recommendation => read it from recommendedItems
    if (json.recommendedItems) {
      const workflow = RecommendationStore.getWorkflow(opts, json.zone);
      this.storeSingleZone({ opts, workflow, recommendedItems: json.recommendedItems });
    } else {
      this.storeMultiZone({ opts, json });
    }
    return true;
  },

  dateAvailable(recommendationConfig) {
    const zones = recommendationConfig.zone.split('|');
    return _.every(zones, (zone) => {
      const workflow = RecommendationStore.getWorkflow(recommendationConfig, zone);
      return zoneRecommendationMap[workflow];
    });
  },

  clear(workflow) {
    if (workflow) {
      delete zoneRecommendationMap[workflow];
    } else {
      zoneRecommendationMap = {};
    }
  },

  getWorkflow(config, zone) {
    const zoneUnique = config.productId ? `${zone}-${config.productId}` : zone;
    return `${config.requester}-${zoneUnique}`;
  },
};


export default RecommendationStore;
